import { defineComponent as t, createBlock as r, openBlock as l, unref as a, mergeProps as p, withCtx as i, createElementVNode as m } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const u = /* @__PURE__ */ t({
  name: "IconInfoFilled",
  __name: "IconInfoFilled",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(o) {
    const n = o;
    return (d, e) => (l(), r(a(c), p(n, { "view-box": "0 0 24 24" }), {
      default: i(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M2.25 12c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75S2.25 17.385 2.25 12m10.5-4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a.75.75 0 0 1 .75-.75h1A1.25 1.25 0 0 1 12.75 11v4.75h.75a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1 0-1.5h.75v-4.5H10.5a.75.75 0 0 1-.75-.75",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  u as default
};
